// extracted by mini-css-extract-plugin
export default {"burgerMenuIcon":"Header_burgerMenuIcon__Eq7Ke","header":"Header_header__xNvES"};